export { default } from './Logo';



// WEBPACK FOOTER //
// ./src/client/js/view/components/Header/Logo/index.js